The link for the button to redirect the candidate to the SEEK authorization page.
